export const setBodyOverflow = (value) => {
  if (value) {
    document.body.classList.add("modal-open");
  } else {
    document.body.classList.remove("modal-open");
  }
};

export const turnOffPullToRefresh = () => {
  window.turnOffPullToRefresh = true;
};

export const turnOnPullToRefresh = () => {
  window.turnOffPullToRefresh = false;
};

